<template>
  <div class="modal fade" id="importContactModal">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
          <div class="modal-header">
          <h3 class="modal-title"> {{$t('exports.text') }}</h3>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x">
                  <i class="fa fa-times"></i>
              </span>
          </div>
          </div>
          <div class="modal-body">
            <button @click.prevent="exportContactFile"  v-if="$can('contact_export')" type="button" class="btn btn-bg-secondary w-100 mb-5" :data-kt-indicator="isLoading ? 'on': ''" :disabled="isLoading">
                        <span class="indicator-label d-flex align-items-center justify-content-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width='20px' height='20px' viewBox="0 0 24 24" fill="none" class="flex-shrink-0">
                        <rect opacity="0.3" x="12.75" y="4.25" width="12" height="2" rx="1"
                            transform="rotate(90 12.75 4.25)" fill="currentColor"></rect>
                        <path
                            d="M12.0573 6.11875L13.5203 7.87435C13.9121 8.34457 14.6232 8.37683 15.056 7.94401C15.4457 7.5543 15.4641 6.92836 15.0979 6.51643L12.4974 3.59084C12.0996 3.14332 11.4004 3.14332 11.0026 3.59084L8.40206 6.51643C8.0359 6.92836 8.0543 7.5543 8.44401 7.94401C8.87683 8.37683 9.58785 8.34458 9.9797 7.87435L11.4427 6.11875C11.6026 5.92684 11.8974 5.92684 12.0573 6.11875Z"
                            fill="currentColor"></path>
                        <path
                            d="M18.75 8.25H17.75C17.1977 8.25 16.75 8.69772 16.75 9.25C16.75 9.80228 17.1977 10.25 17.75 10.25C18.3023 10.25 18.75 10.6977 18.75 11.25V18.25C18.75 18.8023 18.3023 19.25 17.75 19.25H5.75C5.19772 19.25 4.75 18.8023 4.75 18.25V11.25C4.75 10.6977 5.19771 10.25 5.75 10.25C6.30229 10.25 6.75 9.80228 6.75 9.25C6.75 8.69772 6.30229 8.25 5.75 8.25H4.75C3.64543 8.25 2.75 9.14543 2.75 10.25V19.25C2.75 20.3546 3.64543 21.25 4.75 21.25H18.75C19.8546 21.25 20.75 20.3546 20.75 19.25V10.25C20.75 9.14543 19.8546 8.25 18.75 8.25Z"
                            fill="#C4C4C4"></path>
                    </svg>
                        {{ $t('products.export') }}
                        </span>

                <span class="indicator-progress">
                            {{ $t('loading') }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
            </button>
            <button @click.prevent="downloadExcel"  v-if="$can('contact_export')" type="button" class="btn btn-bg-secondary w-100 mb-5" :data-kt-indicator="isLoadingDownload ? 'on': ''" :disabled="isLoadingDownload">
                        <span class="indicator-label d-flex align-items-center justify-content-center gap-2">
                          <svg width='20px' height='20px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' class="flex-shrink-0">
                                <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                                    <g id='download_2_fill' fill-rule='nonzero'>
                                        <path d='M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z' id='MingCute' fill-rule='nonzero'></path><path d='M20,14.5 C20.8284,14.5 21.5,15.1716 21.5,16 L21.5,20 C21.5,21.3807 20.3807,22.5 19,22.5 L5,22.5 C3.61929,22.5 2.5,21.3807 2.5,20 L2.5,16 C2.5,15.1716 3.17157,14.5 4,14.5 C4.82843,14.5 5.5,15.1716 5.5,16 L5.5,19.5 L18.5,19.5 L18.5,16 C18.5,15.1716 19.1716,14.5 20,14.5 Z M12,1.5 C12.8284,1.5 13.5,2.17157 13.5,3 L13.5,12.0355 L15.182,10.3535 C15.7678,9.76776 16.7175,9.76776 17.3033,10.3535 C17.8891,10.9393 17.8891,11.8891 17.3033,12.4749 L13.2374,16.5407 C12.554,17.2242 11.446,17.2242 10.7626,16.5407 L6.6967,12.4749 C6.11091,11.8891 6.11091,10.9393 6.6967,10.3535 C7.28249,9.76776 8.23223,9.76776 8.81802,10.3535 L10.5,12.0355 L10.5,3 C10.5,2.17157 11.1716,1.5 12,1.5 Z' fill='#09244BFF'></path>
                                    </g>
                                </g>
                            </svg>
                        {{ $t('products.download_model') }}
                        </span>

                <span class="indicator-progress">
                            {{ $t('loading') }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
            </button>

            <div class="fv-row fv-plugins-icon-container mb-5" v-if="$can('contact_import')">
                <label class="form-label"></label>
                <div class="d-flex justify-content-center align-items-center">
                <input v-on:change="onContactFileChange" ref="usersFile" class="form-control form-control-solid border border-2" type="file" id="usersFile">
                </div>
                <div class="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>

          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="closeModal"></Button>
            <Button btn-class="btn-sm" type="new" btn-text="button.save" size="7px 30px" @click="importContacts"/>
          </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Button from "@/components/Button.vue"
import {ref} from "vue";
import {useStore} from "vuex";

const store = useStore()
const emits = defineEmits(["reload"])

const type = ref('')
const file = ref('')
const isLoading = ref(false)
const isLoadingImport = ref(false)
const isLoadingDownload = ref(false)

const exportContactFile = async () => {
  try {
    isLoading.value = true
    type.value = 'export'
    await store.dispatch('contacts/exportContact')
  } catch (e) { }
  isLoading.value = false
}

function closeModal(){
  $('#importContactModal').modal('toggle')
}

const onContactFileChange = (event) => {
  file.value = event.target.files[0];
}

const importContacts = async () => {
  type.value = 'import'
  isLoadingImport.value = true
  let response
  try {
    const formData = new FormData();
    formData.append('file', file.value);
    await store.dispatch('contacts/importContact',formData)
    emits("reload")
    type.value = 'export'
    $('#importContactModal').modal('toggle')
    isLoadingImport.value = false
    window.toastr['success'](i18n.global.t('notification.contact_imported'))
  } catch (e) {
    if (response && response.data) {
      window.toastr['error'](response.data.message)
    }
  }
}

const downloadExcel = async () => {
  try {
    isLoadingDownload.value = true
    const downloadLink = document.createElement('a');
    downloadLink.href = '/assets/media/excel/Fichier_modele_contact.xlsx';
    downloadLink.download = 'Fichier_modele_contact.xlsx';
    downloadLink.click();
  } catch (e) { }
  isLoadingDownload.value = false
}
</script>

<style scoped>
input[type="file"]::file-selector-button {
  background-color: #e9ecef;
  cursor: pointer;
}
</style>